import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { legalContent, companyInfo } from '../data/mock';

const LegalSection = () => {
  const [expandedSection, setExpandedSection] = useState('disclaimer');

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  const legalItems = [
    { key: 'disclaimer', ...legalContent.disclaimer },
    { key: 'privacy', ...legalContent.privacy },
    { key: 'terms', ...legalContent.terms }
  ];

  return (
    <section id="legal" className="section section-dark section-padding">
      <div className="container-custom">
        {/* Header */}
        <div className="mb-12">
          <div className="gold-line mb-6" />
          <h2 className="text-3xl md:text-4xl font-semibold mb-4">
            Legal Information
          </h2>
          <p 
            className="text-lg"
            style={{ color: 'var(--text-secondary)' }}
          >
            Important disclosures and policies
          </p>
        </div>

        {/* Accordion */}
        <div className="space-y-4">
          {legalItems.map((item) => (
            <div 
              key={item.key}
              className="legal-section overflow-hidden"
              style={{
                borderColor: expandedSection === item.key ? 'var(--accent-gold)' : 'var(--border-subtle)'
              }}
            >
              <button
                onClick={() => toggleSection(item.key)}
                className="w-full flex items-center justify-between p-0 bg-transparent border-none cursor-pointer text-left"
              >
                <h3 
                  className="text-lg md:text-xl font-semibold"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  {item.title}
                </h3>
                <ChevronDown 
                  size={20} 
                  style={{ 
                    color: 'var(--accent-gold)',
                    transform: expandedSection === item.key ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s ease'
                  }} 
                />
              </button>
              
              <div 
                className="overflow-hidden transition-all duration-300 ease-in-out"
                style={{
                  maxHeight: expandedSection === item.key ? '500px' : '0px',
                  opacity: expandedSection === item.key ? 1 : 0,
                  marginTop: expandedSection === item.key ? '16px' : '0px'
                }}
              >
                <p 
                  className="text-base"
                  style={{ 
                    color: 'var(--text-secondary)',
                    lineHeight: '1.8'
                  }}
                >
                  {item.content}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Main Disclaimer Banner */}
        <div 
          className="mt-12 p-6 text-center"
          style={{ 
            background: 'var(--accent-gold-light)',
            border: '1px solid var(--border-subtle)'
          }}
        >
          <p 
            className="text-sm"
            style={{ color: 'var(--text-secondary)' }}
          >
            <strong style={{ color: 'var(--accent-gold)' }}>{companyInfo.name}</strong> does not provide investment advisory or brokerage services. 
            Information on this website is for informational purposes only.
          </p>
        </div>
      </div>
    </section>
  );
};

export default LegalSection;
